import getFormValue from './getFormValue';

export default getFormValue;
